// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dashboard-view-topbar-left-container{
    border-radius: 0px 0px 25px 0px;
}

.nav-underline .nav-link:focus, .nav-underline .nav-link:hover,
.nav-underline .nav-link:hover,
.nav-underline .nav-link.active{
    border-color: var(--clr-white-base) !important;
}
.nav-link,
.nav-link:hover, .nav-item > .nav-link:hover{
    color: var(--clr-gray-dark);
}
.nav-link.active{
    font-weight: bold;
    color: var(--clr-white-base) !important;
}

#dashboard-user-button-toggle{
    border: none !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: var(--clr-text);
    max-height: 42px;
}

#dashboard-view-topbar-right-container > *{
    width: max-content !important;
}

.iminio-list-item-header > button{
    background-color: var(--clr-gray-base);
    border-radius: 25px !important;
}
.accordion-button:not(.collapsed){
    color: var(--clr-text);
    background-color: var(--clr-orange-light);
    border-color: var(--clr-orange-light) !important;
    border-width: 1px !important;
    box-shadow: 0 0 0 0.2rem var(--clr-orange-light);
}
.iminio-list-item-body{
    background-color: var(--clr-gray-base);
    border-radius: 0px 0px 25px 25px;
    width: 97%;
    margin: auto;
}
.accordion-item{
    border: none;
}
#iminio-dashboard-tabs-container{
    border-radius: 0px 0px 25px 0px;
    align-items: flex-end;
    padding-bottom: -1px;
    height: 43px;
}
.iminio-dashboard-table{
    max-height: 90vh;
    overflow-y: auto;
}
.iminio-dashboard-container{
    max-width: 1200px !important;
    margin: auto;
}

#iminio-dashboard-items-container{
    min-height: 110px;
    max-height: 70vh;
    overflow-y: scroll;
    overflow-x: hidden;
}

#iminio-intervention-pill{
    display: flex;
    flex-direction: row;
    width: max-content;
}

.iminio-intervention-pill-item{
    border: 1px solid var(--clr-blue-base);
    border-left: none;
    padding: 4px 15px;
}
.iminio-intervention-pill-item-active{
    background-color: var(--clr-orange-base);
    border:none !important;
    border-left:none !important;
    border: 1px solid var(--clr-orange-base) !important;
    color: var(--clr-white-base);
    font-weight: bold;
}
.iminio-intervention-pill-item:hover{
    cursor: pointer;
    background-color: var(--clr-orange-light);
}

.iminio-intervention-pill-item-both{
    border: 1px solid var(--clr-blue-base);
    border-radius: 25px;
    max-height: 34px;
}
.iminio-intervention-pill-item-both:hover{
    cursor: pointer;
    background-color: var(--clr-green-light);
}
.iminio-intervention-pill-item-left{
    border-left: 1px solid var(--clr-green-base);
    border-radius: 15px 0px 0px 15px;
}
.iminio-intervention-pill-item-right{
    /* border-left: 1px solid var(--clr-blue-base); */
    border-radius: 0px 15px 15px 0px;
}

.intervention-photo-container{
    overflow: hidden;
    max-height: 200px;
    border: 4px solid transparent;
}
.intervention-photo-container > img{
    width: 100%;
    object-fit: contain;
}
.intervention-photo-container-loading{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-backdrop-filter: blur(2px) brightness(0.9);
            backdrop-filter: blur(2px) brightness(0.9);
    z-index: 20;
}
.intervention-photo-container-delete{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 5px;
    top: 5px;
    padding: 10px;
    border-radius: 25%;
    height: 30px;
    width: 30px;
    background-color: var(--clr-white-base);
    z-index: 30;
}
.intervention-photo-container-delete:hover{
    cursor: pointer;
    filter: brightness(1.1);
}
.intervention-photo-container-small{
    position:relative;
    overflow: hidden;
    width: 180px;
    border: 4px solid transparent;
    max-height: 100px;
}
.intervention-photo-container-small>img{
    width: 100%;
}
.intervention-photo-container:hover > img,
.intervention-photo-container-small:hover > img{
    filter: brightness(0.8);
    cursor: pointer;
}

#iminio-data-list-header-container{
    height: 21.6px !important
}

.iminio-data-list-item{
    opacity: 0%;
    transition: opacity 300ms ease-in-out;
}
.iminio-data-list-item-show{
    opacity: 100%;
}
.condominium-image{
    max-height: 400px !important;
}
.intervention-image{
    max-height: 477px !important;
}
.intervention-image-small{
    max-height: 360px !important;
}

.modal-dialog{
    max-width: fit-content !important;
}

.profile-form-email-edit-icon{
    position: absolute;
    top: 7px;
    right: 15px;
}
.profile-form-email-edit-icon{
    position: absolute;
    top: 4px;
    right: 10px;
    padding: 3px 5px;
    border-radius: 25px;
}
.profile-form-email-edit-icon:hover{
    background-color: #0002;
    color: var(--clr-orange-base);
    cursor: pointer;
}

.profile-form-fullname-edit-icon{
    padding: 3px 5px;
    border-radius: 25px;
}
.profile-form-fullname-edit-icon:hover{
    background-color: #0002;
    color: var(--clr-orange-base);
    cursor: pointer;
}

#iminio-filter-field{
    max-width: 56%;
}

/* @media only screen and (min-width: 2000px) {
    #iminio-dashboard-tabs-container{
        border-radius: 0px 0px 25px 0px;
        align-items: flex-end;
        padding-bottom: -1px;
        height: 900px;
        width: 5000px !important;
    }
  } */`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;;;IAGI,8CAA8C;AAClD;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;AAClC;AACA;IACI,sBAAsB;IACtB,yCAAyC;IACzC,gDAAgD;IAChD,4BAA4B;IAC5B,gDAAgD;AACpD;AACA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,UAAU;IACV,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,2BAA2B;IAC3B,mDAAmD;IACnD,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,wCAAwC;AAC5C;AACA;IACI,4CAA4C;IAC5C,gCAAgC;AACpC;AACA;IACI,iDAAiD;IACjD,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,kDAA0C;YAA1C,0CAA0C;IAC1C,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uCAAuC;IACvC,WAAW;AACf;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;;IAEI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,qCAAqC;AACzC;AACA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;;KAQK","sourcesContent":["#dashboard-view-topbar-left-container{\n    border-radius: 0px 0px 25px 0px;\n}\n\n.nav-underline .nav-link:focus, .nav-underline .nav-link:hover,\n.nav-underline .nav-link:hover,\n.nav-underline .nav-link.active{\n    border-color: var(--clr-white-base) !important;\n}\n.nav-link,\n.nav-link:hover, .nav-item > .nav-link:hover{\n    color: var(--clr-gray-dark);\n}\n.nav-link.active{\n    font-weight: bold;\n    color: var(--clr-white-base) !important;\n}\n\n#dashboard-user-button-toggle{\n    border: none !important;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    color: var(--clr-text);\n    max-height: 42px;\n}\n\n#dashboard-view-topbar-right-container > *{\n    width: max-content !important;\n}\n\n.iminio-list-item-header > button{\n    background-color: var(--clr-gray-base);\n    border-radius: 25px !important;\n}\n.accordion-button:not(.collapsed){\n    color: var(--clr-text);\n    background-color: var(--clr-orange-light);\n    border-color: var(--clr-orange-light) !important;\n    border-width: 1px !important;\n    box-shadow: 0 0 0 0.2rem var(--clr-orange-light);\n}\n.iminio-list-item-body{\n    background-color: var(--clr-gray-base);\n    border-radius: 0px 0px 25px 25px;\n    width: 97%;\n    margin: auto;\n}\n.accordion-item{\n    border: none;\n}\n#iminio-dashboard-tabs-container{\n    border-radius: 0px 0px 25px 0px;\n    align-items: flex-end;\n    padding-bottom: -1px;\n    height: 43px;\n}\n.iminio-dashboard-table{\n    max-height: 90vh;\n    overflow-y: auto;\n}\n.iminio-dashboard-container{\n    max-width: 1200px !important;\n    margin: auto;\n}\n\n#iminio-dashboard-items-container{\n    min-height: 110px;\n    max-height: 70vh;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n#iminio-intervention-pill{\n    display: flex;\n    flex-direction: row;\n    width: max-content;\n}\n\n.iminio-intervention-pill-item{\n    border: 1px solid var(--clr-blue-base);\n    border-left: none;\n    padding: 4px 15px;\n}\n.iminio-intervention-pill-item-active{\n    background-color: var(--clr-orange-base);\n    border:none !important;\n    border-left:none !important;\n    border: 1px solid var(--clr-orange-base) !important;\n    color: var(--clr-white-base);\n    font-weight: bold;\n}\n.iminio-intervention-pill-item:hover{\n    cursor: pointer;\n    background-color: var(--clr-orange-light);\n}\n\n.iminio-intervention-pill-item-both{\n    border: 1px solid var(--clr-blue-base);\n    border-radius: 25px;\n    max-height: 34px;\n}\n.iminio-intervention-pill-item-both:hover{\n    cursor: pointer;\n    background-color: var(--clr-green-light);\n}\n.iminio-intervention-pill-item-left{\n    border-left: 1px solid var(--clr-green-base);\n    border-radius: 15px 0px 0px 15px;\n}\n.iminio-intervention-pill-item-right{\n    /* border-left: 1px solid var(--clr-blue-base); */\n    border-radius: 0px 15px 15px 0px;\n}\n\n.intervention-photo-container{\n    overflow: hidden;\n    max-height: 200px;\n    border: 4px solid transparent;\n}\n.intervention-photo-container > img{\n    width: 100%;\n    object-fit: contain;\n}\n.intervention-photo-container-loading{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    backdrop-filter: blur(2px) brightness(0.9);\n    z-index: 20;\n}\n.intervention-photo-container-delete{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    padding: 10px;\n    border-radius: 25%;\n    height: 30px;\n    width: 30px;\n    background-color: var(--clr-white-base);\n    z-index: 30;\n}\n.intervention-photo-container-delete:hover{\n    cursor: pointer;\n    filter: brightness(1.1);\n}\n.intervention-photo-container-small{\n    position:relative;\n    overflow: hidden;\n    width: 180px;\n    border: 4px solid transparent;\n    max-height: 100px;\n}\n.intervention-photo-container-small>img{\n    width: 100%;\n}\n.intervention-photo-container:hover > img,\n.intervention-photo-container-small:hover > img{\n    filter: brightness(0.8);\n    cursor: pointer;\n}\n\n#iminio-data-list-header-container{\n    height: 21.6px !important\n}\n\n.iminio-data-list-item{\n    opacity: 0%;\n    transition: opacity 300ms ease-in-out;\n}\n.iminio-data-list-item-show{\n    opacity: 100%;\n}\n.condominium-image{\n    max-height: 400px !important;\n}\n.intervention-image{\n    max-height: 477px !important;\n}\n.intervention-image-small{\n    max-height: 360px !important;\n}\n\n.modal-dialog{\n    max-width: fit-content !important;\n}\n\n.profile-form-email-edit-icon{\n    position: absolute;\n    top: 7px;\n    right: 15px;\n}\n.profile-form-email-edit-icon{\n    position: absolute;\n    top: 4px;\n    right: 10px;\n    padding: 3px 5px;\n    border-radius: 25px;\n}\n.profile-form-email-edit-icon:hover{\n    background-color: #0002;\n    color: var(--clr-orange-base);\n    cursor: pointer;\n}\n\n.profile-form-fullname-edit-icon{\n    padding: 3px 5px;\n    border-radius: 25px;\n}\n.profile-form-fullname-edit-icon:hover{\n    background-color: #0002;\n    color: var(--clr-orange-base);\n    cursor: pointer;\n}\n\n#iminio-filter-field{\n    max-width: 56%;\n}\n\n/* @media only screen and (min-width: 2000px) {\n    #iminio-dashboard-tabs-container{\n        border-radius: 0px 0px 25px 0px;\n        align-items: flex-end;\n        padding-bottom: -1px;\n        height: 900px;\n        width: 5000px !important;\n    }\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
